<template>
  <FileUploader
    name="files"
    limit="2"
    :fileMaxSize="24"
    @options="getFileuploaderOptions"
    @created="createFileUploaderInstance"
    @mounted="createFileUploaderInstance"
    extensions="image/*"
    :files="JSON.stringify(arrayTemp)"
    :fileuploader-Default="defaultImage"
  ></FileUploader>
</template>

<script>
import $ from "jquery";
import FileUploader from "@/plugins/Fileuploader.vue";
import { mapGetters, mapActions } from "vuex";
export default {
  name: "avtarInput",
  components: {
    FileUploader,
  },
  data: () => ({
    errorDialog: null,
    errorText: "",
    uploadFieldName: "file",
    maxSize: 1024,
    arrayTemp: [],
    fileUploadApi: null,
  }),
  props: {
    type:String, 
    avatar:[String,File],
    defaultImage:String
  },
  watch: {
    avatar: {
      handler: function (val) {
        console.log('val',val)
        this.arrayTemp = [];
        if (typeof val != "string"&&val) {
          this.addFileInApi(val, "name", val.size);
        } else if(val) {
          this.getDetailImage();
        }
      },
      immediate: true,
    }
  },
  methods: {
    ...mapActions("UserController", ["UPLOAD_AVARTA_USER"]),
    createFileUploaderInstance(cmp) {
      this.fileUploadApi = cmp;
    },
    getFileuploaderOptions(cmp) {
      let _this = this;
      var name = cmp.name;
      this.$forceUpdate();
      cmp.options = {
        limit: 2,
        extensions: ['image/*'],
        fileMaxSize: 10,
        changeInput: ' ',
        theme: 'avatar',
        addMore: true,
        enableApi: true,
        thumbnails: {
          box: '<div class="fileuploader-wrapper">' +
              '<div class="fileuploader-items"></div>' +
              '<div class="fileuploader-droparea" data-action="fileuploader-input"><i class="fileuploader-icon-main"></i></div>' +
              '</div>' +
              '<div class="fileuploader-menu">' +
                '<button type="button" class="fileuploader-menu-open"><i class="fileuploader-icon-menu"></i></button>' +
                '<ul>' +
                  '<li><a data-action="fileuploader-input"><i class="fileuploader-icon-upload"></i> ${captions.upload}</a></li>' +
                  '<li><a data-action="fileuploader-edit"><i class="fileuploader-icon-edit"></i> ${captions.edit}</a></li>' +
                  '<li><a data-action="fileuploader-remove"><i class="fileuploader-icon-trash"></i> ${captions.remove}</a></li>' +
                '</ul>' +
              '</div>',
          item: '<div class="fileuploader-item">' +
                  '${image}' +
                '<span class="fileuploader-action-popup" data-action="fileuploader-edit"></span>' +
                '<div class="progressbar3" style="display: none"></div>' +
              '</div>',
          item2: null,
          itemPrepend: true,
          startImageRenderer: true,
          canvasImage: false,
            _selectors: {
              list: '.fileuploader-items'
            },
            popup: {
              arrows: false,
              onShow: function(item) {
                item.popup.html.addClass('is-for-avatar');
                          item.popup.html.on('click', '[data-action="remove"]', function(e) {
                              item.popup.close();
                              item.remove();
                          }).on('click', '[data-action="cancel"]', function(e) {
                              item.popup.close();
                          }).on('click', '[data-action="save"]', function(e) {
                  if (item.editor && !item.isSaving) {
                    item.isSaving = true;
                                item.editor.save();
                  }
                  if (item.popup.close)
                    item.popup.close();
                          });
                      },
              onHide: function(item) {
                if (!item.isSaving && !item.uploaded && !item.appended) {
                  item.popup.close = null;
                  item.remove();
                }
              } 	
            },
            onItemShow: function(item, listEl, parentEl, newInputEl, inputEl) {
              console.log(';item',item)
              _this.updateFiles();
              if (item.choosed){
                item.html.addClass('is-image-waiting');
              }
              parentEl
              .find(".fileuploader-menu ul a")
              .show()
              .filter('[data-action="fileuploader-input"]')
              .show();
            },
          // onItemShow: function (item, listEl, parentEl, newInputEl, inputEl) {
          //   //
          //   _this.updateFiles();
          //   if (item.choosed) item.html.addClass("is-image-waiting");
          //   parentEl
          //     .find(".fileuploader-menu ul a")
          //     .show()
          //     .filter('[data-action="fileuploader-input"]')
          //     .show();
          // },
          onImageLoaded: function(item, listEl, parentEl, newInputEl, inputEl) {
              if (item.choosed && !item.isSaving) {
                if (item.reader.node && item.reader.width >= 120 && item.reader.height >= 120) {
                  item.image.hide();
                  item.popup.open();
                  item.editor.cropper();
                } else {
                  item.remove();
                  alert('The image is too small!');
                }
              } else if (item.data.isDefault){
                item.html.addClass('is-default');
              }
              else if (item.image.hasClass('fileuploader-no-thumbnail')){
                item.html.hide();
              }
          },
          onItemRemove: function(html) {
            html.fadeOut(250, function() {
              html.remove();
            });
          },
        },
        dragDrop: {
          container: '.fileuploader-wrapper'
        },
        editor: {
          maxWidth: 512,
          maxHeight: 512,
          quality: 90,
          cropper: {
            showGrid: false,
            ratio: '1:1',
            minWidth: 120,
            minHeight: 120,
          },
          onSave: function (
            base64,
            item,
            listEl,
            parentEl,
            newInputEl,
            inputEl
          ) {
            var api = $.fileuploader.getInstance(inputEl);
            const blob = _this.dataURLtoFile(base64, item.name);
            item.file = blob;
            if (item.data.uploaded) {
              console.log("item", item);
              if (api.getFiles().length == 2 && (api.getFiles()[0].data.isDefault || api.getFiles()[0].upload)){
                api.getFiles()[0].remove();
              }
              parentEl.find('.fileuploader-menu ul a').show();
              item.file.edit = true;
            } else {
              item.file.edit = true;
            }
            _this.sendfile(item, listEl, parentEl, newInputEl, inputEl);
          },
        },
        upload: {
          onComplete: null,
        },
        afterRender: function (listEl, parentEl, newInputEl, inputEl) {
          var api = $.fileuploader.getInstance(inputEl);
			
          // remove multiple attribute
          inputEl.removeAttr('multiple');
                
          // set drop container
          api.getOptions().dragDrop.container = parentEl.find('.fileuploader-wrapper');
          
          // disabled input
          if (api.isDisabled()) {
            parentEl.find('.fileuploader-menu').remove();
          }
          
          // [data-action]
          parentEl.on('click', '[data-action]', function() {
            var $this = $(this),
              action = $this.attr('data-action'),
              item = api.getFiles().length ? api.getFiles()[api.getFiles().length-1] : null;
            
            switch (action) {
              case 'fileuploader-input':
                api.open();
                break;
              case 'fileuploader-edit':
                if (item && item.popup) {
                  if (!$this.is('.fileuploader-action-popup'))
                    item.popup.open();
                  item.editor.cropper();
                }
                break;
              case 'fileuploader-retry':
                if (item && item.upload.retry)
                  item.upload.retry();
                break;
              case 'fileuploader-remove':
                if (item)
                  item.remove();
                break;
            }
          });
          
          // menu
          $('body').on('click', function(e) {
            var $target = $(e.target),
              $parent = $target.closest('.fileuploader');
            
            $('.fileuploader-menu').removeClass('is-shown');
            if ($target.is('.fileuploader-menu-open') || $target.closest('.fileuploader-menu-open').length){
              $parent.find('.fileuploader-menu').addClass('is-shown');
            }
          });
        },
        onEmpty: function (listEl, parentEl, newInputEl, inputEl) {
          var api = $.fileuploader.getInstance(inputEl),
          defaultAvatar = inputEl.attr('fileuploader-default');
          
          if (defaultAvatar && !listEl.find('> .is-default').length){
            api.append({name: '', type: 'image/png', size: 0, file: defaultAvatar, data: {isDefault: true, popup: false, listProps: {is_default: true}}});
          }
          parentEl.find('.fileuploader-menu ul a').hide().filter('[data-action="fileuploader-input"]').show();
        },
        onRemove: function (item, listEl, parentEl, newInputEl, inputEl) {
          if (item.name && (item.appended || item.uploaded))
              _this.updateFiles();
          return true;
        },
        onSelect: function (item, listEl, parentEl, newInputEl, inputEl) {
          // console.log("item onSelect",item)
          // _this.sendfile(item, listEl, parentEl, newInputEl, inputEl);
        },
        captions: $.extend(true, {}, $.fn.fileuploader.languages["en"], {
          edit: this.$t("modify"),
          upload: this.$t("upload"),
          remove: this.$t("delete"),
          errors: {
            filesLimit: this.$t("Only 1 image is allowed to upload"),
          },
        }),
      };
    },
    updateFiles() {
      console.log(this.fileUploadApi)
      if(this.fileUploadApi.api){
        let files = this.fileUploadApi.api.getFiles();
      }
    },
    sendfile(item, listEl, parentEl, newInputEl, inputEl) {
      if (this.type == "logo") {
        this.$emit("childToParent", item);
      } else {
        item.data.formData = new FormData();

        if (item && item.file) {
          item.data.fileuploader = 1;
          item.data.name = item.name;
          item.data.editing = item.uploaded;

          item.data.formData.append(inputEl.attr("name"), item.file, item.name);
        }

        item.image.hide();
        item.html.removeClass("upload-complete");
        parentEl.find('[data-action="fileuploader-edit"]').hide();
        let formData = new FormData();
        formData.append("profile_image", item.file);
        this.UPLOAD_AVARTA_USER(formData)
          .then((result) => {
            var api = $.fileuploader.getInstance(inputEl),
              $progressBar = item.html.find(".progressbar3"),
              data = {
                files: [],
                hasWarnings: false,
                isSuccess: true,
                warnings: [],
              };

            if (result && result.data){
              data.files.push({ name: result.data.data.profile_image });
              this.$forceUpdate();
            } else {data.hasWarnings = true;}
            // console.log("api.getFiles()", api.getFiles());
            if (api.getFiles().length > 1){ api.getFiles()[0].remove();}

            // if success
            if (data.isSuccess && data.files[0]) {
              item.name = data.files[0].name;
            }

            // if warnings
            if (data.hasWarnings) {
              for (var warning in data.warnings) {
                alert(data.warnings[warning]);
              }

              item.html
                .removeClass("upload-successful")
                .addClass("upload-failed");
              return this.onError ? this.onError(item) : null;
            }

            delete item.isSaving;
            item.html
              .addClass("upload-complete")
              .removeClass("is-image-waiting");
            $progressBar
              .find("span")
              .html('<i class="fileuploader-icon-success"></i>');
            parentEl.find('[data-action="fileuploader-edit"]').show();
            setTimeout(function () {
              $progressBar.fadeOut(450);
            }, 1250);
            item.image.fadeIn(250);
            this.imageSavedGetNewImage();
            
          })
          .catch(() => {
            var $progressBar = item.html.find(".progressbar3");

            item.html.addClass("upload-complete");
            if (item.upload.status != "cancelled")
              $progressBar
                .find("span")
                .attr("data-action", "fileuploader-retry")
                .html('<i class="fileuploader-icon-retry"></i>');
          });
      }
    },
    dataURLtoFile(dataurl, filename) {
      var arr = dataurl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, { type: mime });
    },
    imageSavedGetNewImage() {
      console.log("imageSavedGetNewImage")
      this.$emit("imageSavedGetNewImage");
    },
    async getDetailImage() {
      await axios
        .get(this.avatar, {
          responseType: "arraybuffer",
        })
        .then((result) => {
          let parts = this.avatar.split("/");
          let name = parts[parts.length - 1];
          let replaceSize = name.replace("832x468", "250x141");
          let splitDot = name.split(".");
          let _ext = splitDot[splitDot.length - 1];
          let blob = new Blob([result.data], {
            type: result.headers["content-type"],
          });

          let file = new File([blob], name, blob);
          this.addFileInApi(file, name, result.headers["content-length"]);
        });
    },

    addFileInApi(file, name, size) {
      let objImageDetail = {
        appended: true,
        name: name,
        size: size,
        type: "image/jpg",
        file: file,
        local: file,
        uploaded: true,
        choosed: true,
        isSuccess: true,
        isDefault:false,
        title: name,
        data: {
          thumbnail: file, // item custom thumbnail; if false will disable the thumbnail (optional)
          readerCrossOrigin: "anonymous", // fix image cross-origin issue (optional)
          readerForce: true, // prevent the browser cache of the image (optional)
          readerSkip: false, // skip file from reading by rendering a thumbnail (optional)
          popup: true, // remove the popup for this file (optional)
          uploaded: true,
        },
      };
      this.arrayTemp[0] = objImageDetail;
      this.fileUploadApi.api.append(objImageDetail);
    },
  },
};
</script>
<style>
@import "style.scss";
</style>
